import { http } from '../api/client'
import type { LoginResponse, Usuario } from '../api/types'
import type { LoginOutcome } from './mfaApi'

export interface LoginInput {
  email: string
  senha: string
}

export const authApi = {
  /** POST /auth/login — campo é `senha` (não `password`).
   *
   *  Devolve a sessão OU um desafio de segundo fator. Ver `isMfaChallenge`. */
  login(input: LoginInput): Promise<LoginOutcome> {
    return http.post<LoginOutcome>('/auth/login', input)
  },
  /** GET /auth/me — usuário da sessão atual. */
  me(): Promise<Usuario> {
    return http.get<Usuario>('/auth/me')
  },
  /** POST /auth/change-password — troca a senha e revoga as sessões antigas.
   *
   *  Devolve uma sessão NOVA: a revogação vale para as outras abas, e sem o par
   *  de tokens de volta a própria aba que trocou a senha cairia no login. */
  changePassword(senhaAtual: string, senhaNova: string): Promise<LoginResponse> {
    return http.post<LoginResponse>('/auth/change-password', {
      senha_atual: senhaAtual,
      senha_nova: senhaNova,
    })
  },
  /** POST /auth/definir-senha — cria a senha definitiva de quem entrou com a
   *  temporária. Não pede a senha atual: a sessão parcial já é a prova dela. */
  definirSenha(senhaNova: string): Promise<LoginResponse> {
    return http.post<LoginResponse>('/auth/definir-senha', { senha_nova: senhaNova })
  },
  /** POST /auth/forgot-password — dispara a senha temporária por e-mail. A
   *  resposta é sempre a mesma, exista a conta ou não. */
  forgotPassword(email: string): Promise<{ sent: boolean }> {
    return http.post<{ sent: boolean }>('/auth/forgot-password', { email })
  },
}
